import { Button, ChevronLeftIcon, ConsentOrdersPathName } from "@fla/components";
import { useNavigate } from "react-router-dom";

export default function Welcome() {
  const navigateTo = useNavigate();

  const onNext = () => navigateTo(ConsentOrdersPathName.InitialDetails);
  const goBack = () => navigateTo("/");

  return (
    <section className="w-full md:w-10/12 lg:max-w-2xl h-fit mx-auto my-10">
      <div className="bg-white rounded-xl w-full h-fit px-10 py-5 shadow-md mx-auto my-7">
        <p className="mt-5">
          Hello,
          <br />
          <br />
          We need to collect some information from you so we can prepare your consent orders.
          <br />
          <br />
          In <b>Relationship Details</b>, you will be asked to provide details about your relationship, income,
          children, and other information the court requires.
          <br />
          <br />
          Once you have completed this, the information will be submitted to a lawyer who will use it to draft your
          consent order documents.
          <br />
          <br />
          Please complete the form listing the assets and debts of the relationship, and return this separately back to
          your lawyer by email.
          <br />
          <br />
          Remember you and your former partner have a legal obligation to make full and frank disclosure of your
          financial circumstances. This means you each must disclose all relevant information about income, assets,
          liabilities, and financial resources in the consent order documents.
          <br />
          <br />
          Not making full and frank disclosure can have serious consequences including the court setting aside the
          consent orders or make a costs order against the non-disclosing person.
          <br />
          <br />
          We understand that the process of completing a consent order can be overwhelming, and we are here to assist
          you in any way we can.
          <br />
          <br />
          Thank you for choosing to use Split Wise.
          <br />
          <br />
          Kind regards,
          <br />
          <br />
          Split Wise
        </p>

        <div className="flex justify-between items-center w-full mt-16">
          <button
            className="text-gray-500 font-semibold hover:text-gray-600 flex items-center justify-center space-x-1 group"
            onClick={goBack}
          >
            <ChevronLeftIcon strokeColor="group-hover:text-gray-600" classes="w-3.5 h-3.5" />
            <span>Back</span>
          </button>

          <Button type="button" onClick={onNext} className="h-10 px-12 flex justify-center items-center">
            Next
          </Button>
        </div>
      </div>
    </section>
  );
}
